import { reduxForm, Field } from "redux-form";
import { RenderTextField, RenderCheckboxField } from "../../../../common/components/FormFields";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Button } from "@material-ui/core";
import formsCss from "../../../../common/styles/forms.css";
import validate from "./validate";
// eslint-disable-next-line no-unused-vars

const SideLinksSectionForm = props => {
    const { isEdit, handleSubmit, errors } = props;

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-xs-12">
                    <Field
                        name="name"
                        errorRes={errors && errors.name}
                        component={RenderTextField}
                        label={"Name"}
                        fullWidth
                        rows={5}
                        rowsMax={5}
                    />
                </div>

                <div className="col-xs-12">
                    <Field
                        name="isExpanded"
                        label="Show as expanded on start"
                        component={RenderCheckboxField}
                        errorRes={errors && errors.isExpanded}
                    />
                </div>
            </div>

            <div css={formsCss.actions}>
                <Button type="submit" variant="contained" color="primary" css={formsCss.btnSubmit}>
                    {isEdit ? "Edit" : "Add"} section
                </Button>
            </div>
        </form>
    );
};

export default reduxForm({
    form: "SideLinksSectionForm",
    enableReinitialize: true,
    validate,
})(SideLinksSectionForm);
